<template>
  <div class="contact">
    <div class="map">
      <baidu-map
        class="bmView"
        :center="location"
        :zoom="zoom"
        ak="5viza4iNZL9A2FruB0mpaLjQmenITEfr"
      >
      <bm-marker :position="{ lng: location.lng, lat: location.lat }" name=""> </bm-marker>
      </baidu-map>
    </div>
    <div class="call">
      <h2 class="title">{{$t('contact.title')}}</h2>
      <div class="company">
       {{$t('contact.company')}}
      </div>
      <div class="call-nav">
        <div>
          <img src="../../assets/image/location.svg" alt="" />
          <div>{{$t('contact.call')}}</div>
          <div>{{$t('contact.address')}}</div>
        </div>
        <div>
          <img src="../../assets/image/phone.svg" alt="" />
          <div>{{$t('contact.consulting')}}</div>
          <div>4006062838</div>
        </div>
        <div>
          <img src="../../assets/image/email.svg" alt="" />
          <div>{{$t('contact.email')}}</div>
          <div>hongpiao.mi@etao-it.com</div>
        </div>
      </div>
    </div>
    <div class="qr-code">
      <img src="../../assets/image/qr-code.png" alt="" />
      <div>{{$t('contact.code')}}</div>
    </div>
  </div>
</template>
<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
export default {
  components: {
    BaiduMap,
    BmMarker,
  },
  name: "",
  data() {
    return {
      location: {
        lng: 114.074075,
        lat: 22.666005,
      },
      zoom: 19,
    };
  },
};
</script>
<style scoped>
.contact {
  padding-top: 80px;
}
.map > .bmView {
  width: 100%;
  height: 450px;
  border-top: 1px dotted #888888;
  border-bottom: 1px dotted #888888;
}
.call {
  margin: 0 200px;
  border-bottom: 1px solid #cfcfcf;
}
.title {
  margin: 50px 0;
  text-align: center;
  font-size: 20px;
  color: #121212;
  line-height: 45px;
  position: relative;
}
h2:after {
  content: "";
  position: absolute;
  left: 48.5%;
  bottom: 0;
  height: 3px;
  width: 22px;
  background-color: red;
}
.call .company {
  text-align: center;
  font-size: 14px;
  color: #7e7e7c;
  line-height: 40px;
  margin: 0 100px;
}
.call-nav {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  text-align: center;
  line-height: 30px;
  margin-bottom: 40px;
  color: #6e6e6e;
}
.qr-code {
  margin-top: 45px;
  margin-bottom: 150px;
  text-align: center;
  line-height: 30px;
  color: #6e6e6e;
}
</style>
